import template from './batch.html';
import controller from './batch.controller';
import './batch.scss';

let batchComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default batchComponent;


// WEBPACK FOOTER //
// ./client/app/components/batch/batch.component.js